import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import { BaseQuestionReportComponent } from '../../../bases';
import { useQuestionContext } from '../../../core'; // import { AnswerItem } from './components';
// import { Checkbox } from 'antd';

import styled from '@xstyled/styled-components';
import { getSize, getColor, TextToHTMLTransformerComponent } from '@lib/common'; // import { useState } from 'react';

import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledStatsBar = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  margin-bottom: ", ";\n"])), getColor('fillIntSubActive'), getSize('radiusSm'), getSize('padding16'));
var StyledStatCell = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: ", ";\n"])), getSize('padding16'));
var StyledStatCellDivider = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 1px;\n  background: ", ";\n  flex-shrink: 0;\n"])), getColor('fillIntSubActive'));
var StyledStatCellLabel = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1rem;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledStatCellValue = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.2;\n"])), getSize('typo24'), function (_ref) {
  var $isError = _ref.$isError;
  return $isError ? getColor('errorActive') : getColor('contentTitle');
});
var StyledStatCellDescription = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.4;\n  margin-top: 2px;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledAnswerList = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledAnswerRow = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  padding: ", " 0 ", " 0;\n"])), getSize('padding8'), getSize('padding8'));
var StyledAnswerMeta = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledAnswerLabelWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n"])));
var StyledCheckIcon = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), getColor('successBgActive'));
var StyledAnswerLabel = styled.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  line-height: 1.5;\n"])), getSize('typo14'), function (_ref2) {
  var $isCorrect = _ref2.$isCorrect;
  return $isCorrect ? '700' : '400';
}, function (_ref3) {
  var $isCorrect = _ref3.$isCorrect;
  return $isCorrect ? getColor('successActive') : getColor('contentBody');
});
var StyledAnswerPercentage = styled.span(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n  flex-shrink: 0;\n  margin-left: ", ";\n"])), getSize('typo14'), function (_ref4) {
  var $isCorrect = _ref4.$isCorrect;
  return $isCorrect ? getColor('successActive') : getColor('contentBody');
}, getSize('padding12'));
var StyledTrack = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 8px;\n  background: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), getColor('fillIntSubActive'), getSize('radiusRounded'));
var StyledBar = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", "%;\n  background: ", ";\n  border-radius: ", ";\n  transition: width 0.5s ease;\n"])), function (_ref5) {
  var $width = _ref5.$width;
  return $width;
}, function (_ref6) {
  var $isCorrect = _ref6.$isCorrect;
  return $isCorrect ? getColor('fillIntActive') : getColor('fillIntHighlighted');
}, getSize('radiusRounded'));

var StatsBar = function StatsBar(_ref7) {
  var totalCandidates = _ref7.totalCandidates,
      accuracyRate = _ref7.accuracyRate,
      correctCount = _ref7.correctCount,
      labels = _ref7.labels;
  return /*#__PURE__*/_jsxs(StyledStatsBar, {
    children: [/*#__PURE__*/_jsxs(StyledStatCell, {
      children: [/*#__PURE__*/_jsx(StyledStatCellLabel, {
        children: labels.totalCandidates
      }), /*#__PURE__*/_jsx(StyledStatCellValue, {
        children: totalCandidates
      }), /*#__PURE__*/_jsx(StyledStatCellDescription, {
        children: labels.studentsAnsweredDesc
      })]
    }), /*#__PURE__*/_jsx(StyledStatCellDivider, {}), /*#__PURE__*/_jsxs(StyledStatCell, {
      children: [/*#__PURE__*/_jsx(StyledStatCellLabel, {
        children: labels.accuracyRate
      }), /*#__PURE__*/_jsxs(StyledStatCellValue, {
        $isError: accuracyRate === 0,
        children: [accuracyRate, "%"]
      }), /*#__PURE__*/_jsx(StyledStatCellDescription, {
        children: labels.studentsCorrectDesc
      })]
    }), /*#__PURE__*/_jsx(StyledStatCellDivider, {}), /*#__PURE__*/_jsxs(StyledStatCell, {
      children: [/*#__PURE__*/_jsx(StyledStatCellLabel, {
        children: labels.correctAnswers
      }), /*#__PURE__*/_jsx(StyledStatCellValue, {
        children: correctCount
      }), /*#__PURE__*/_jsx(StyledStatCellDescription, {
        children: labels.studentsChoseDesc
      })]
    })]
  });
};

var AnswerBarChart = function AnswerBarChart(_ref8) {
  var answerReports = _ref8.answerReports,
      optionLabel = _ref8.optionLabel;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var multipleChoiceQuestion = question;
  var correctAnswerIds = new Set(((multipleChoiceQuestion === null || multipleChoiceQuestion === void 0 ? void 0 : multipleChoiceQuestion.correctAnswers) || []).map(function (ca) {
    return ca.answerId;
  }));
  return /*#__PURE__*/_jsx(StyledAnswerList, {
    children: (multipleChoiceQuestion.answers || []).map(function (answer, index) {
      var _answerReport$totalSe, _answerReport$selecte, _answerReport$selecte2;

      var isCorrect = correctAnswerIds.has(answer.id.toString());
      var answerReport = answerReports === null || answerReports === void 0 ? void 0 : answerReports.find(function (report) {
        return report.answerId === answer.id.toString();
      });
      return /*#__PURE__*/_jsxs(StyledAnswerRow, {
        children: [/*#__PURE__*/_jsxs(StyledAnswerMeta, {
          children: [/*#__PURE__*/_jsxs(StyledAnswerLabelWrapper, {
            children: [isCorrect && /*#__PURE__*/_jsx(StyledCheckIcon, {
              children: /*#__PURE__*/_jsx("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 12 12",
                fill: "none",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M2 6l3 3 5-5",
                  stroke: "#16a34a",
                  strokeWidth: "1.8",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })
              })
            }), /*#__PURE__*/_jsx(StyledAnswerLabel, {
              $isCorrect: isCorrect,
              children: /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [optionLabel, " ", index + 1, ":"]
                }), TextToHTMLTransformerComponent({
                  value: answer.description
                })]
              })
            })]
          }), /*#__PURE__*/_jsxs(StyledAnswerPercentage, {
            $isCorrect: isCorrect,
            children: [(_answerReport$totalSe = answerReport === null || answerReport === void 0 ? void 0 : answerReport.totalSelectedAnswers) !== null && _answerReport$totalSe !== void 0 ? _answerReport$totalSe : 0, " Students (", (_answerReport$selecte = answerReport === null || answerReport === void 0 ? void 0 : answerReport.selectedAnswerPercentage) !== null && _answerReport$selecte !== void 0 ? _answerReport$selecte : 0, "%)"]
          })]
        }), /*#__PURE__*/_jsx(StyledTrack, {
          children: /*#__PURE__*/_jsx(StyledBar, {
            $width: (_answerReport$selecte2 = answerReport === null || answerReport === void 0 ? void 0 : answerReport.selectedAnswerPercentage) !== null && _answerReport$selecte2 !== void 0 ? _answerReport$selecte2 : 0,
            $isCorrect: isCorrect
          })
        })]
      }, answer.id.toString());
    })
  });
};

export var MultipleChoiceReportComponent = function MultipleChoiceReportComponent(_ref9) {
  var states = _ref9.states,
      actions = _ref9.actions;
  var totalParticipants = states.totalParticipants,
      accuracy = states.accuracy,
      correctCount = states.correctCount,
      answerReports = states.answerReports,
      multipleChoiceLabel = states.multipleChoiceLabel;
  return /*#__PURE__*/_jsxs(BaseQuestionReportComponent, {
    states: states,
    actions: actions,
    children: [/*#__PURE__*/_jsx(StatsBar, {
      totalCandidates: totalParticipants,
      accuracyRate: accuracy,
      correctCount: correctCount,
      labels: multipleChoiceLabel
    }), /*#__PURE__*/_jsx(AnswerBarChart, {
      answerReports: answerReports,
      optionLabel: multipleChoiceLabel.option
    })]
  });
};